import React from 'react';
import styled from 'styled-components';
import {radius, colors} from '../modules/styles';
import {Icon} from '@blueprintjs/core';

export default function SelectBox({
  children,
  disabled = false,
  hasError = false,
}) {
  return (
    <Comp
      className={`${disabled ? 'disabled' : ''} ${hasError ? 'error' : ''}`}
    >
      {children} <Icon icon="caret-down" />
    </Comp>
  );
}

const Comp = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0;
  cursor: pointer;
  border-radius: ${radius};
  border: 1px solid ${colors.gray2};
  padding: 4px 8px;
  background-color: white;
  width: 100%;

  &.disabled {
    cursor: not-allowed;
  }

  &.error {
    border: 1px solid ${colors.danger};
    /* background-color: ${colors.dangerLight}; */
  }

  .bp3-icon {
    margin-left: 30px;
  }
`;
